import React, { useState } from 'react';

// Keep incomplete decimal text local; calculations still receive finite numbers.
export default function SltpDecimalInput({ value, onChange, onFocus, onBlur, onKeyDown, step = 1, ...props }) {
  const [draft, setDraft] = useState(null);
  return <input {...props} type="text" inputMode="decimal"
    value={draft ?? value}
    onFocus={event => { setDraft(String(value ?? '')); onFocus?.(event); }}
    onChange={event => {
      const raw = event.target.value;
      if (!/^-?\d*(?:\.\d*)?$/.test(raw)) return;
      setDraft(raw);
      onChange?.(event);
    }}
    onBlur={event => { setDraft(null); onBlur?.(event); }}
    onKeyDown={event => {
      onKeyDown?.(event);
      if (event.defaultPrevented || !['ArrowUp', 'ArrowDown'].includes(event.key)) return;
      event.preventDefault();
      const current = Number(draft ?? value) || 0;
      const next = String(Number((current + (event.key === 'ArrowUp' ? 1 : -1) * Number(step)).toPrecision(12)));
      setDraft(next);
      onChange?.({ target: { value: next } });
    }} />;
}
